module.exports = __webpack_public_path__ + "img/Invasion-CRC_GSE225857.bb6352e0.png";